import { DocumentType, BankAccountType } from '../../domain/enums/bank-account.js';

const makeInitialValues = () => ({
  businessOwner: {
    fullName: '',
    email: '',
    phoneNumber: '',
    documentNumber: '',
    documentType: DocumentType.CPF,
    countryCode: 'BR'
  },
  bankAccount: {
    bankNumber: '001',
    agencyNumber: '',
    agencyCheckNumber: '',
    accountNumber: '',
    accountCheckNumber: '',
    accountType: BankAccountType.TYPE_CHECKING
  },
  billingAddress: {
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    postalCode: '',
    countryCode: 'BR'
  },
  isPixKey: true
});

export { makeInitialValues };
